import { ReactComponent as ChatIcon } from '@assets/icons/V4/session-details/chat-history-icon.svg';
import Button from '@components/V4/Button';

import { useAuthState } from '@contexts/AuthContext';
import { SessionDetailsContext } from '@modules/SessionDetails/context/SessionDetailsContext';
import { useContext, useState } from 'react';
import SessionDetailsEmptyState from '../components/SessionDetailsEmptyState';
import SessionDetailsLayoutCard from '../components/SessionDetailsLayoutCard';
import SessionDetailsChatMessage from './SessionDetailsChatMessage';
import { useTranslation } from 'apps/agora/src/TranslationContext';

interface ChatMessage {
  user: string;
  message: {
    text: string;
    at: string;
    file?: string;
    error?: boolean;
  };
}

interface SessionDetailsChatProps {
  chatMessages?: ChatMessage[];
  startTime?: string;
  accentColor: string;
}

const SessionDetailsChat = (props: SessionDetailsChatProps) => {
  const { chatMessages, startTime, accentColor } = props;
  const { t } = useTranslation();

  const [showEntireChat, setShowEntireChat] = useState(false);

  const showEntireChatButtonHandler = () => {
    setShowEntireChat((prev) => !prev);
  };

  const { fullName } = useAuthState();
  const { isLoading } = useContext(SessionDetailsContext);

  const messages = showEntireChat ? chatMessages : chatMessages?.slice(0, 5);

  return (
    <SessionDetailsLayoutCard
      isLoading={isLoading}
      icon={<ChatIcon className="text-white" />}
      className="gap-8"
      title={t('sessionDetails.chat.title')}
    >
      {messages?.length ? (
        <>
          <div className="flex flex-col gap-6">
            {messages.map((message, index) => (
              <SessionDetailsChatMessage
                key={`${message.message}-${index}`}
                startTime={startTime}
                timestamp={message.message.at}
                accentColor={accentColor}
                author={message.user}
                authenticatedUserFullName={fullName}
                message={message.message?.text ?? ''}
              />
            ))}
          </div>

          {chatMessages && chatMessages?.length > 5 && (
            <div className="flex justify-center">
              <Button
                variant="secondary"
                buttonText={showEntireChat ? t('common.showLess') : t('common.showEntireChat')}
                onClick={showEntireChatButtonHandler}
              />
            </div>
          )}
        </>
      ) : (
        <SessionDetailsEmptyState
          icon={<ChatIcon className="text-customGrey" />}
          text={t('sessionDetails.chat.noHistory')}
        />
      )}
    </SessionDetailsLayoutCard>
  );
};

export default SessionDetailsChat;
